import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Tariff } from '../../tariffs/tariff.model';

@Injectable({
  providedIn: 'root',
})

export class SelectKkmTariffState {
  private readonly activeTariff$ = new BehaviorSubject<Tariff | null>(null);
  private readonly availableTariffs$ = new BehaviorSubject<Tariff[]>([]);

  setTariffList(tariffs: Tariff[], tariffId?: number): void {
    const activeTariff = tariffs.find(tariff => tariff.id === tariffId) ?? null;
    const availableTariffs = tariffs.filter(tariff => tariff.id !== tariffId);
    this.activeTariff$.next(activeTariff);
    this.availableTariffs$.next(availableTariffs);
  }

  getActiveTariff(): Observable<Tariff | null> {
    return this.activeTariff$.asObservable();
  }

  getAvailableTariff(): Observable<Tariff[]> {
    return this.availableTariffs$.asObservable();
  }
}
